var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
import { t } from 'i18next';
import { consume } from '@lit-labs/context';
import { feedbackContext } from './FeedbackContext';
let Navigation = class Navigation extends BaseComponent {
    render() {
        const { canSubmit, canSetNext, canSetPrev } = this.questionsAndStatus;
        const submitButton = this.screen.isMobile && canSubmit() ? html `
      <trust-button primary small @click='${this.submit}' dataTest="submit">
        ${t('Complete')}
      </trust-button>
    ` : nothing;
        return html `
      <div class='relative flex justify-between w-full my-16'>
        <button class='disabled:invisible outline-none border-0 bg-transparent cursor-pointer' @click='${this.setPrev}' ?disabled='${!canSetPrev}' data-test='mobile-previous' aria-label=${t('Back')}>
          <trust-icon name="ChevronLeft" classNames="w-24 h-24 fill-black hover:scale-125"></trust-icon>
        </button>
        <button class='disabled:invisible outline-none border-0 bg-transparent cursor-pointer' @click='${this.setNext}' ?disabled='${!canSetNext}' data-test='mobile-next' aria-label=${t('Next')}>
          <trust-icon name="ChevronRight" classNames="w-24 h-24 fill-black hover:scale-125"></trust-icon>
        </button>
        ${submitButton}
      </div>
    `;
    }
};
__decorate([
    property({ attribute: false })
], Navigation.prototype, "setPrev", void 0);
__decorate([
    property({ attribute: false })
], Navigation.prototype, "setNext", void 0);
__decorate([
    property({ attribute: false })
], Navigation.prototype, "submit", void 0);
__decorate([
    consume({ context: feedbackContext, subscribe: true })
], Navigation.prototype, "questionsAndStatus", void 0);
Navigation = __decorate([
    customElement('trust-feedback-navigation')
], Navigation);
export { Navigation };
//# sourceMappingURL=Navigation.js.map